import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "sms-modal-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "To", -1)
const _hoisted_11 = { class: "col-sm-10" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Message", -1)
const _hoisted_14 = { class: "col-sm-10 body-editor" }
const _hoisted_15 = { class: "modal-footer d-flex justify-content-between align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger mb-0"
}
const _hoisted_17 = ["disabled"]

import $ from 'jquery';
import { computed, onMounted, inject } from 'vue';
import _get from "lodash/get";
import moment from "moment-timezone";
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import {
  Dictionary,
  Report,
  Booking,
  SMSTemplate,
  SMS,
  SMSLogs,
  Tenant,
  Landlord,
  Bookedby,
} from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSModal',
  props: {
    id: {},
    name: {},
    title: {},
    reporttype: {},
    target: {},
    chronorder: {},
    customer: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');

const dictionary = computed((): Dictionary => store.getters['dictionary/current'] as Dictionary);
const tenantsms = computed((): SMS => store.getters['smstemplates/tenantsms'] as SMS);
const booking = computed((): Booking => store.getters['diary/booking'] as Booking);

// Convert actions and mutations
const findSMSTemplates = (query?: {
  reporttype?: string;
  target?: string;
  chronorder?: string[];
  managedtype?: string;
  customer?: string;
}): Promise<SMSTemplate> => {
  return store.dispatch('smstemplates/findSMSTemplates', query);
};

const filterSMSTemplate = (query?: {
  reporttype?: string;
  target?: string;
  chronorder?: string[];
  managedtype?: string;
  customer?: string;
}): Promise<SMSTemplate> => {
  return store.dispatch('smstemplates/filterSMSTemplate', query);
};

const loadAllSMSTemplates = (): Promise<SMSTemplate[]> => {
  return store.dispatch('smstemplates/getSMSTemplates');
};

const setTenantSMS = (sms: SMS): void => {
  store.commit('smstemplates/setTenantSMS', sms);
};

const sendSMS = (sms: SMS): Promise<string> => {
  return store.dispatch('diary/sendSMS', sms);
};

const setClientSMSDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('smstemplates/setClientSMSDeep', payload);
};

const setTenantSMSDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('smstemplates/setTenantSMSDeep', payload);
};

const setBookingDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('diary/setBookingDeep', payload);
};

const getSMSLogs = (bookingid: string): Promise<SMSLogs> => {
  return store.dispatch('diary/getSMSLogs', bookingid);
};

const updateTenantSMSConfirmationSent = (bookingid: string): Promise<any> => {
  return store.dispatch('diary/updateTenantSMSConfirmationSent', bookingid);
};

onMounted(async () => {
  //await loadAllSMSTemplates();
});

const init = () => {
  setTemplate();
  setTargetnumbers();
}


const setTargetnumbers = () => {
  let tonumbers: string[] = [];
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    tonumbers = booking.value.tenants
      .filter((t: Tenant) => t.ttmobile)
      .map((t: Tenant) => t.ttmobile);
  }
  to.value = tonumbers.join(",");
};

const setTemplate = async () => {
  setTenantSMSDeep({ path: "body", data: "", });
  setTenantSMSDeep({ path: "bookingid", data: "", });

  // Check if this is a last minute booking
  let lastMinuteTemplate = await filterSMSTemplate({
    reporttype: props.reporttype,
    target: props.target,
    chronorder: [props.chronorder, 'Last Minute'],
    managedtype: booking.value.managedtype,
    customer: props.customer,
  });

  let chronorderfilter = [];
  if (props.chronorder) {
    chronorderfilter.push(props.chronorder);
  }

  if (lastMinuteTemplate?.id) {
    const todaymoment = moment().utc();
    const bookingmoment = moment(booking.value.startdate).utc().startOf("day");
    let daysleft = moment.duration(bookingmoment.diff(todaymoment)).asDays();
    if (daysleft <= lastMinuteTemplate.daysbefore) chronorderfilter.push('Last Minute');
  }

  await findSMSTemplates({
    reporttype: props.reporttype,
    target: props.target,
    chronorder: chronorderfilter,
    managedtype: booking.value.managedtype,
    customer: props.customer,
  }).then((smstemplate: SMSTemplate) => {
    if (smstemplate.id) {
      let sms: SMS = new SMS(smstemplate);
      setTenantSMS(sms);
      setTenantSMSDeep({
        path: "body",
        data: convertToPlain(normalise(smstemplate.body)),
      });
      if (booking.value && booking.value.id) {
        setTenantSMSDeep({
          path: "bookingid",
          data: booking.value.id,
        });
        setTargetnumbers();
      }
    }
  })
    .catch((err: any) => actProperty.displayError(err));
};

const convertToPlain = (html: string) => {
  var tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || "";
}

const normalise = (html: string): string => {
  placeholderMap.forEach((bookingpath: string, placeholder: string) => {
    let replacevalue = _get(booking.value, bookingpath, "**");
    if (placeholder === "Type of job external") {
      replacevalue = formatReportType(replacevalue);
    } else if (placeholder === "Booked with name") {
      replacevalue = preparebookedbyname(booking.value.bookedby);
    } else if (placeholder === "Landlord name") {
      replacevalue = preparelandlordname(booking.value.landlords);
    } else if (placeholder === "Tenant name") {
      replacevalue = preparetenantname(booking.value.tenants);
    } else if (placeholder === "Invoice amount" && booking.value.invoices) {
      let total = booking.value.invoices.reduce(
        (sum, invoice: Report) => sum + invoice.totalFees(),
        0
      );
      if(isNaN(total)) total = 0;
      if (booking.value.paymentinadv)
        replacevalue = actProperty.formatCurrency(total);
      else replacevalue = "";
    } else if (placeholder === "Date") {
      replacevalue = moment(replacevalue).utc().format("DD/MM/YYYY");
    } else if (placeholder === "Appointment time") {
      replacevalue = moment(replacevalue).utc().format("hh:mm A");
    }

    html = html.replaceAll(
      `<span class="placeholder">[${placeholder}]</span>`,
      replacevalue
    );
  });
  return html;
}

const placeholderMap: Map<string, string> = new Map<string, string>([
  ["Type of job external", "jobtype"],
  ["Address", "address.displayaddress"],
  ["Booked with name", "bookedbyname"],
  ["Appointment time", "appointmenttime"],
  ["Client", "customer.companyName"],
  ["Branch", "customer.branchName"],
  ["Access Branch", "keypickupbranchname"],
  ["Landlord name", "llname"],
  ["Tenant name", "ttname"],
  ["Date", "startdate"],
  ["Invoice amount", ""],
  ["Start time", "starttime"],
  ["End time", "endtime"],
]);

const formatReportType = (type: string) => {
  return actProperty.formatReportType(type, dictionary.value);
}

// Setters and getters
const sms = computed(() => {
  return tenantsms.value;
});

const to = computed({
  get: () => tenantsms.value.to.join(","),
  set: (data: string) => {
    setTenantSMSDeep({ path: `to`, data: data.split(",") });
  }
});

const body = computed({
  get: () => tenantsms.value.body,
  set: (data: string) => {
    setTenantSMSDeep({ path: `body`, data });
  }
});

const tenantnames = computed(() => {
  let names: string[] = [];
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    names = booking.value.tenants
      .filter((t: Tenant) => t.ttmobile && t.ttname)
      .map((t: Tenant) => t.ttname);
  }
  return names.join(",");
});

const preparetenantname = (tenants: Tenant[]) => {
  let value: string[] = [];
  if (tenants && tenants.length) {
    value = tenants
      .filter((t: Tenant) => t.ttmobile && t.ttname)
      .map((t: Tenant) => {
        let name = "";
        let splits = t.ttname.split(" ");
        if (splits.length > 0) name = splits[0];
        return name;
      });
  }
  return value.join(", ");
};

const preparelandlordname = (landlords: Landlord[]) => {
  let value: string[] = [];
  if (landlords && landlords.length) {
    value = landlords
      .filter((l: Landlord) => l.llmobile && l.llname)
      .map((l: Landlord) => {
        let name = "";
        let splits = l.llname.split(" ");
        if (splits.length > 0) name = splits[0];
        return name;
      });
  }
  return value.join(", ");
};

const preparebookedbyname = (bookedby: Bookedby[]) => {
  let value: string[] = [];
  if (bookedby && bookedby.length) {
    value = bookedby
      .filter((b: Bookedby) => b.bbmobile && b.bbname)
      .map((b: Bookedby) => {
        let name = "";
        let splits = b.bbname.split(" ");
        if (splits.length > 0) name = splits[0];
        return name;
      });
  }
  return value.join(", ");
};

const canSend = () => {
  return sms.value.body;
}

const send = async () => {
  if (canSend()) {
    await sendSMS(sms.value)
      .then((response: string) => {
        if (response) {
          toasted.success(`SMS successfully sent`);
        }
      })
      .then(() => {
        updateTenantSMSConfirmationSent(booking.value.id);
        hide();

      })
      .then(() => {
        getSMSLogs(booking.value.id);
        hide();

      });
  }
}
const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};
__expose({ init, show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`smsmodal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((to).value = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    to.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  rows: "10",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    body.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Cancel "),
          (booking.value.provisional)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_16, "This is a provisional booking."))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (send()), ["prevent"])),
            disabled: !canSend()
          }, " Send ", 8, _hoisted_17)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})